import { render, staticRenderFns } from "./TransactionsList.vue?vue&type=template&id=b011f402&scoped=true&"
import script from "./TransactionsList.vue?vue&type=script&lang=js&"
export * from "./TransactionsList.vue?vue&type=script&lang=js&"
import style0 from "./TransactionsList.vue?vue&type=style&index=0&id=b011f402&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b011f402",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VChip } from 'vuetify/lib/components/VChip';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VChip,VDataTable,VIcon,VProgressCircular,VTooltip})
